module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "media-reorder-album"
    }
  }, [_c('h2', [_vm._v("Reorder Albums")]), _vm._v(" "), (!_vm.isSaving) ? _c('form', [_c('ul', _vm._l((_vm.albums), function(album, index) {
    return _c('li', [_c('div', {
      staticClass: "reorder-buttons"
    }, [(index > 0) ? _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveUp(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-up"
    })]) : _vm._e(), _vm._v(" "), (index < _vm.albums.length - 1) ? _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveDown(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-down"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "avatar-container"
    }, [(album.hasAvatar) ? _c('img', {
      staticClass: "media-avatar",
      attrs: {
        "src": ("https://www.develteam.com/userdata/avatars/media_" + (album.id) + ".jpg?v=" + (album.avatarId)),
        "alt": album.title + ' album',
        "title": album.title + ' album'
      }
    }) : _c('img', {
      staticClass: "media-avatar",
      attrs: {
        "src": "https://www.develteam.com/userdata/avatar_blank_100.jpg",
        "alt": album.title + ' album',
        "title": album.title + ' album'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title-container"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(album.title))])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fae7022!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/FormReorderMediaAlbums.vue
// module id = 895
// module chunks = 2